module.exports = __webpack_public_path__ + "img/hoslogo19.fd0ded88.png";